import { Trans } from '@lingui/react';
import React, { useContext } from 'react';
import { useBreakpoint, NavBarContext, Nav, callAllHandlers, Button } from '@landr/maestro';
import '../../../../../../utils/analytics/index.es.js';
import { getWebAppLinkLibraryOrMasteringPreview, getWebAppLink, getPluginsLink, openLink } from '../../../../../../utils/links.es.js';
import { useLinkClickHandler } from '../../../../hooks/useLinkClickHandler.es.js';
import { usePricingLink } from '../../../../hooks/usePricingLink.es.js';
import { useLinkAnalyticsV2Handler } from '../../../../hooks/useLinkAnalyticsV2Handler.es.js';
import { useIsCurrentLink } from '../../../../hooks/useIsCurrentLink.es.js';
import { NavBarLearnItems } from './components/NavBarLearnItems.es.js';
import { GuestSiteDistributionTab, Links } from '../../../../../../enums/Links.es.js';
import { NavBarItems } from './components/NavBarItems.es.js';
import { CtaGoal } from '../../../../../../utils/analytics/PlatformAnalyticsV2Service.generated.es.js';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { getSamplesLink, getSessionsLink, getNetworkLink, getGuestSiteLink } from '@landr/core';
import { NavItems } from '../../../../../../enums/NavItems.es.js';

var NavBarMainNav = function NavBarMainNav() {
  var isMobile = useBreakpoint('lg');
  var isSmallMobile = useBreakpoint('sm');
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env,
    language = _useNavBarContext.language,
    user = _useNavBarContext.user,
    isUserLoading = _useNavBarContext.isUserLoading,
    onLogin = _useNavBarContext.onLogin;
  var sendAnalyticsV2Handler = useLinkAnalyticsV2Handler();
  var linkClickHandler = useLinkClickHandler();
  var pricingLink = usePricingLink();
  var _useContext = useContext(NavBarContext),
    closePanel = _useContext.closePanel;
  var guestsiteDistributionLink = GuestSiteDistributionTab[language];
  var isLoggedOut = user === null && !isUserLoading;
  var urls = {
    library: getWebAppLinkLibraryOrMasteringPreview(env, isLoggedOut),
    distribution: getWebAppLink(env, Links.Releases),
    pricing: pricingLink,
    samples: getSamplesLink(env),
    plugins: getPluginsLink(env),
    projects: getWebAppLink(env, Links.Projects),
    sessions: getSessionsLink(env),
    network: getNetworkLink(env),
    rewards: getWebAppLink(env, Links.Referrals)
  };
  var isCurrentLink = useIsCurrentLink();
  var handleOnLogin = function handleOnLogin() {
    return onLogin === null || onLogin === void 0 ? void 0 : onLogin(false);
  };
  var handleOnSignUp = function handleOnSignUp() {
    return onLogin === null || onLogin === void 0 ? void 0 : onLogin(true);
  };
  return /*#__PURE__*/React.createElement(Nav, {
    isVertical: isMobile,
    size: isMobile ? 'lg' : 'sm'
  }, /*#__PURE__*/React.createElement(NavBarItems, {
    closeDrawer: closePanel
  }), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    px: "xs",
    onClick: callAllHandlers(closePanel, sendAnalyticsV2Handler(CtaGoal.GotoLibrary, 'Master', urls.library), linkClickHandler(openLink, urls.library)),
    href: urls.library,
    isCurrent: isCurrentLink(NavItems.Mastering)
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "IkTa4u"
  }))), /*#__PURE__*/React.createElement(Nav.Item, null, isLoggedOut ? /*#__PURE__*/React.createElement(Nav.Link, {
    px: "xs",
    href: getGuestSiteLink(env, guestsiteDistributionLink),
    isCurrent: isCurrentLink(NavItems.Distribution)
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "vU/Hht"
  })) : /*#__PURE__*/React.createElement(Nav.Link, {
    px: "xs",
    onClick: callAllHandlers(closePanel, sendAnalyticsV2Handler(CtaGoal.GotoDistribution, 'Distribution', urls.distribution), linkClickHandler(openLink, urls.distribution)),
    href: urls.distribution,
    isCurrent: isCurrentLink(NavItems.Distribution)
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "vU/Hht"
  }))), /*#__PURE__*/React.createElement(NavBarLearnItems, {
    closeDrawer: closePanel
  }), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    px: "xs",
    onClick: callAllHandlers(closePanel, sendAnalyticsV2Handler(CtaGoal.ViewPricing, 'Pricing', urls.pricing), linkClickHandler(openLink, urls.pricing)),
    href: urls.pricing,
    isCurrent: isCurrentLink(NavItems.Pricing)
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "aHCEmh"
  }))), isSmallMobile && isLoggedOut && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Button, {
    my: "xs",
    isRounded: true,
    size: "sm",
    variant: "primary",
    kind: "solid",
    onClick: handleOnSignUp
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "e+RpCP"
  }))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Button, {
    my: "xs",
    isRounded: true,
    size: "sm",
    variant: "ghost",
    kind: "solid",
    onClick: handleOnLogin
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "sQia9P"
  })))));
};

export { NavBarMainNav };
